import { reactive } from "vue";

// Shared registry for the bottom banners (PWA install, push opt-in).
// Eligible banners register themselves; the lowest-priority entry is the
// front card, the rest peek out behind it like a card deck. When the front
// banner is dismissed/approved it unregisters and the next one promotes.
const state = reactive({ banners: [] });

export function registerBanner(name, priority = 99) {
  if (state.banners.some((banner) => banner.name === name)) return;
  state.banners.push({ name, priority });
  state.banners.sort((a, b) => a.priority - b.priority);
}

export function unregisterBanner(name) {
  const index = state.banners.findIndex((banner) => banner.name === name);
  if (index !== -1) state.banners.splice(index, 1);
}

export function bannerIndex(name) {
  return state.banners.findIndex((banner) => banner.name === name);
}
